<template>
  <div class="error-box no-fav-box">
    <!-- <p>code:{{ code }}</p>
    <p>resData:{{ resData }}</p>
    <p>resError:{{ resError }}</p>
    <p>userData:{{ userData }}</p> -->
    <p v-if="!userList.length && !loading" class="txt">暂无权限进入本系统,请联系系统管理员</p>
    <Nodata v-if="loading" :loading="loading" empty-txt="暂无权限进入本系统,请联系系统管理员" />

    <van-popup
      v-model="showRoleSelectPopup"
      class="role-select-popup-container"
      :close-on-click-overlay="false"
      round
    >
      <div class="role-select-box">
        <div class="role-header">请选择登录身份</div>
        <div class="role-list">
          <div
            v-for="(role, index) in rolePopupList"
            :key="index"
            class="role-option"
            @click="onSelectRole(role)"
          >
            <span class="role-name">{{ role.role_name }}</span>
            <van-icon name="arrow" color="#999" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { wecomAuth, getUserInfo } from '@/api/user';
import loginMixins from '@/mixins/loginMixins';
import Nodata from '@/components/Nodata';
import { setLocalStorage } from '@/utils/index';
import { Popup, Icon } from 'vant';

// 员工企业微信登录
export default {
  components: {
    Nodata,
    [Popup.name]: Popup,
    [Icon.name]: Icon
  },
  mixins: [loginMixins],
  data() {
    return {
      userList: [],
      code: '',
      resData: '',
      userData: '',
      resError: '',
      userError: ''
    };
  },
  mounted() {
    this.getCode();
  },
  methods: {
    getCode() {
      this.userList = [];
      let code = this.$route.query.code;
      // https://hcp360-demo-bsc.lekinsights.cn/api/weixin/login?code=P951Z7szHgoVrjoEgF6FbfPWT0HqPiGZM9UWl-m0jWY
      this.loading = true;
      this.code = code;
      wecomAuth(code).then(res => {
        /*
        示例的返回结果：
        {
          "isSuccess": true,
          "message": "string",
          "data": {
            "user": {
              "login_user_id": "508339",
              "login_user_name": "李晓理",
              "login_territory_id": "MRS1017",
              "login_territory_name": "MRS1017",
              "login_territory_type": "MR",
              "login_roles": [{
                "role_id": "2",
                "role_name": "销售",
                "is_sales": true,
                "territory_id": "MRS1017"
              }],
              "login_role_id": "2",
              "login_role_name": "销售",
              "user_id": "508339",
              "user_name": "李晓理",
              "territory_id": "MRS1017",
              "territory_name": "MRS1017",
              "territory_type": "MR",
              "role_id": "2",
              "role_name": "销售"
            },
            "loginType": "WECOMUSER",
            "loginId": "508339",
            "authType": "NAMINGUSER",
            "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI1MDgzMzkiLCJuYW1lIjoi5p2O5pmT55CGIiwic2VlZCI6ImYxZDBjZDk3OGQzYjRlZmE4ZTBkMjNmNTg2MGYyOWMyIiwidXNlciI6IntcImxvZ2luX3VzZXJfaWRcIjpcIjUwODMzOVwiLFwibG9naW5fdXNlcl9uYW1lXCI6XCLmnY7mmZPnkIZcIixcImxvZ2luX3RlcnJpdG9yeV9pZFwiOlwiTVJTMTAxN1wiLFwibG9naW5fdGVycml0b3J5X25hbWVcIjpcIk1SUzEwMTdcIixcImxvZ2luX3RlcnJpdG9yeV90eXBlXCI6XCJNUlwiLFwibG9naW5fcm9sZXNcIjpbe1wicm9sZV9pZFwiOlwiMlwiLFwicm9sZV9uYW1lXCI6XCLplIDllK5cIixcImlzX3NhbGVzXCI6dHJ1ZSxcInRlcnJpdG9yeV9pZFwiOlwiTVJTMTAxN1wifV0sXCJsb2dpbl9yb2xlX2lkXCI6XCIyXCIsXCJsb2dpbl9yb2xlX25hbWVcIjpcIumUgOWUrlwiLFwidXNlcl9pZFwiOlwiNTA4MzM5XCIsXCJ1c2VyX25hbWVcIjpcIuadjuaZk-eQhlwiLFwidGVycml0b3J5X2lkXCI6XCJNUlMxMDE3XCIsXCJ0ZXJyaXRvcnlfbmFtZVwiOlwiTVJTMTAxN1wiLFwidGVycml0b3J5X3R5cGVcIjpcIk1SXCIsXCJyb2xlX2lkXCI6XCIyXCIsXCJyb2xlX25hbWVcIjpcIumUgOWUrlwifSIsIm5iZiI6MTc2OTQxNTE1NSwiZXhwIjoxNzY5NDIyMzU1LCJpYXQiOjE3Njk0MTUxNTUsImlzcyI6IkhDUDM2MCIsImF1ZCI6IkhDUDM2MCJ9.JhqUQc2c4frnRrTCi1kQdXOMCYFB3v4kk9tfAmzpCHQ",
            "start": "2026-01-26T16:12:35.0207082+08:00",
            "expiration": "2026-01-26T18:12:35.0207094+08:00",
            "expirationType": "FIX",
            "seed": "f1d0cd978d3b4efa8e0d23f5860f29c2"
          },
        }
        */
        this.resData = JSON.stringify(res);
        if (res.isSuccess && res.data && res.data.user && res.data.user.user_id) {
          if (res.data.token) {
            setLocalStorage('token', res.data.token);
            setLocalStorage('seed', res.data.seed);
          }
          const userData = res.data.user;
          this.loginObj.userName = userData.user_name;
          this.loginObj.userId = userData.user_id;
          this.userList = [userData];
          this.loginFn('oauth2', userData);
        } else {
          this.loading = false;
        }
      }).catch(e => {
        this.resError = 'error=' + JSON.stringify(e);
        this.loading = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/var.scss';
.no-fav-box {
  min-width: 250px;
  padding-top: 60px;
  .txt {
    font-size: 13px;
    color: #707070;
    & + .txt {
      margin-top: 20px;
    }
  }
  .cube-btn {
    // width: 1.44rem;
    padding: 10px 40px;
    font-size: 14px;
    border-radius: 20px;
    margin-top: 30px;
    margin-bottom: 50px;
  }
}
.radius-btn {
  border-radius: 20px;
}

.role-select-popup-container {
  width: 80%;
  max-width: 320px;
  border-radius: 16px;
  overflow: hidden;
}
.role-select-box {
  background: white;
  padding: 0;
}
.role-header {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding: 24px 0 16px;
  color: #333;
}
.role-list {
  padding: 0 20px 24px;
}
.role-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  padding: 16px 20px;
  margin-bottom: 12px;
  border-radius: 12px;
  font-size: 16px;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.role-option:active {
  background: #eef1f6;
  border-color: #dcdfe6;
  transform: scale(0.98);
}
.role-name {
  flex: 1;
}
</style>
